import { render, staticRenderFns } from "./SuiteOwners.vue?vue&type=template&id=1301737c"
import script from "./SuiteOwners.vue?vue&type=script&lang=ts"
export * from "./SuiteOwners.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports